import { render, staticRenderFns } from "./announcementCate.vue?vue&type=template&id=60c0857e&scoped=true&"
import script from "./announcementCate.vue?vue&type=script&lang=js&"
export * from "./announcementCate.vue?vue&type=script&lang=js&"
import style0 from "./announcementCate.vue?vue&type=style&index=0&id=60c0857e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0857e",
  null
  
)

export default component.exports